export const getDateString = (date: any) => {
  const day1 = date[0].substring(8, 10);
  const day2 = date[1].substring(8, 10);
  const month1 = date[0].substring(5, 7);
  const month2 = date[1].substring(5, 7);
  const year1 = date[0].substring(0, 4);
  const year2 = date[1].substring(0, 4);

  const isSameYear = year1 === year2;
  const isSameMonth = month1 === month2;

  const date1 =
    day1 +
    (!isSameMonth || !isSameYear ? " " + translateToMonth(month1) : "") +
    (!isSameYear ? " " + year1 : "");
  const date2 = day2 + " " + translateToMonth(month2) + " " + year2;

  return date[0] === date[1] ? date2 : date1 + " - " + date2;
};

const translateToMonth = (month: any) => {
  if (month === "01") return "styczeń";
  if (month === "02") return "luty";
  if (month === "03") return "marzec";
  if (month === "04") return "kwiecień";
  if (month === "05") return "maj";
  if (month === "06") return "czerwiec";
  if (month === "07") return "lipiec";
  if (month === "08") return "sierpień";
  if (month === "09") return "wrzesień";
  if (month === "10") return "październik";
  if (month === "11") return "listopad";
  if (month === "12") return "grudzień";
  return "";
};
